import {makeObservable, observable, runInAction} from "mobx";
import {observer} from "mobx-react";
import {PropsWithChildren} from "react";
import styled from "styled-components";
import {TextInputBox} from "../../../basic-ui-components/form/textinput.box";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {Label} from "../boxes/label";
import {ShowcaseContentContainerBox} from "../boxes/showcase-content-container/showcase-content-container.box";
import {ShowcaseConfigurationBox} from "../boxes/showcase-configuration/showcase-configuration.box";


const ThemedBox = styled.div<{
    text: string;
    background: string;
    border: string;
    fontPreset: string;
    fontSize: number;
}>`
    color: ${(p) => p.theme.colors[p.text] || "transparent"};
    background-color: ${(p) => p.theme.colors[p.background] || "transparent"};
    border: 5px solid ${(p) => p.theme.colors[p.border] || "transparent"};
    ${(p) => p.theme.font.presets[p.fontPreset] || p.theme.font.presets.body}
    font-size: ${(p) => p.fontSize || "1.6"}rem;

    margin: 15px 0;
    padding: 15px;

`;

@observer
export class TypographyColorAndPresetShowcase extends OrbitComponent {
    constructor(props: PropsWithChildren) {
        super(props);
        makeObservable(this);
    }

    @observable.ref
    background: string = "background";

    @observable.ref
    textColor: string = "text";

    @observable.ref
    boxBorder: string = "boxBorder";

    @observable.ref
    fontPreset: string = "body";

    @observable.ref
    fontSize: number = 1.6;

    render() {
       return <ShowcaseContentContainerBox>
            <ShowcaseConfigurationBox>
                <h3>BACKGROUNDS: </h3>
                <div>
                    {[
                        "brandPrimary", "brandPrimaryDark", "brandPrimaryLight", "brandPrimaryContrast",
                        "brandSecondary", "brandSecondaryDark", "brandSecondaryLight", "brandSecondaryContrast",
                        "backgroundDark", "backgroundMiddleDark", "background", "backgroundLight", "backgroundHover", "backgroundActive", "backgroundContrast",
                        "iconBackgroundActive", "logoBackground"
                    ].map((background) =>
                        <div key={background}>
                            <input
                                type="radio" name="background" id={"background_" + background} value={background}
                                checked={this.background === background}
                                onChange={() => {
                                    runInAction(() => {
                                        this.background = background;
                                    })
                                }}
                            />
                            <Label htmlFor={"background_" + background}>{background}</Label>
                        </div>
                    )}
                </div>
            </ShowcaseConfigurationBox>
            <ShowcaseConfigurationBox>
                <h3>TEXT COLORS: </h3>
                <div>
                    {[
                        "brandPrimary", "brandPrimaryDark", "brandPrimaryLight", "brandPrimaryContrast",
                        "brandSecondary", "brandSecondaryDark", "brandSecondaryLight", "brandSecondaryContrast",
                        "textDark", "textMiddleDark", "text", "textLight", "textHover", "textActive", "textContrast",
                        "moneyColor"
                    ].map((textColor) =>
                        <div key={textColor}>
                            <input
                                type="radio" name="textColor" id={"textColor_" + textColor} value={textColor}
                                checked={this.textColor === textColor}
                                onChange={() => {
                                    runInAction(() => {
                                        this.textColor = textColor;
                                    })
                                }}
                            />
                            <Label htmlFor={"textColor_" + textColor}>{textColor}</Label>
                        </div>
                    )}
                </div>
            </ShowcaseConfigurationBox>
            <ShowcaseConfigurationBox>
                <h3>BOX BORDER: </h3>
                <div>
                    {[
                        "brandPrimary", "brandPrimaryDark", "brandPrimaryLight", "brandPrimaryContrast",
                        "brandSecondary", "brandSecondaryDark", "brandSecondaryLight", "brandSecondaryContrast",
                        "boxBorderDark", "boxBorderMediumDark", "boxBorder", "boxBorderLight", "boxBorderLighter", "boxBorderContrast",
                        "modalDialogBorder"
                    ].map((boxBorder) =>
                        <div key={boxBorder}>
                            <input
                                type="radio" name="boxBorder" id={"boxBorder_" + boxBorder} value={boxBorder}
                                checked={this.boxBorder === boxBorder}
                                onChange={() => {
                                    runInAction(() => {
                                        this.boxBorder = boxBorder;
                                    })
                                }}
                            />
                            <Label htmlFor={"boxBorder_" + boxBorder}>{boxBorder}</Label>
                        </div>
                    )}
                </div>
            </ShowcaseConfigurationBox>
            <ShowcaseConfigurationBox>
                <h3>FONT PRESETS: </h3>
                <div>
                    {[
                        "thin", "light", "regular", "medium", "body", "bold", "black", "ultra", "secondary"
                    ].map((fontPreset) =>
                        <div key={fontPreset}>
                            <input
                                type="radio" name="fontPreset" id={"fontPreset_" + fontPreset} value={fontPreset}
                                checked={this.fontPreset === fontPreset}
                                onChange={() => {
                                    runInAction(() => {
                                        this.fontPreset = fontPreset;
                                    })
                                }}
                            />
                            <Label htmlFor={"fontPreset_" + fontPreset}>{fontPreset}</Label>
                        </div>
                    )}
                </div>
                <div>
                    <TextInputBox
                        type="number"
                        style={{fontSize: "1.6rem", width: "80px"}}
                        min={1}
                        max={3}
                        step={0.01}
                        name="fontSize" id="fontSize" value={this.fontSize}
                        onChange={(ev) => {
                            runInAction(() => {
                                this.fontSize = Math.max(1, Math.min(3, parseFloat(ev.target.value)));
                            })
                        }}
                    /> REM
                </div>
            </ShowcaseConfigurationBox>

           <div style={{flexBasis: "100%"}}>
                <ThemedBox
                    text={this.textColor}
                    background={this.background}
                    border={this.boxBorder}
                    fontPreset={this.fontPreset}
                    fontSize={this.fontSize}
                >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </ThemedBox>
           </div>
        </ShowcaseContentContainerBox>
    }
}
